import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import { protectedRouteGuard } from '@/utils/routeGuards'

import { Loading } from '@/components/Loading'

const AssignSubnetsPage = lazy(
  () => import('@/features/Network/pages/AssignSubnetsPage'),
)

export const Route = createFileRoute('/infra/network/assign-subnets')({
  beforeLoad: protectedRouteGuard,
  loader: () => ({
    crumb: 'Assign Subnets',
  }),
  component: () => (
    <Suspense fallback={<Loading />}>
      <AssignSubnetsPage />
    </Suspense>
  ),
})
